import Redirector from './Redirector';

export default Redirector;
